import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'programming-advertisement-control',
    templateUrl: 'programming-advertisement.control.html',
    standalone: false,
})
export class ProgrammingAdvertisementTab extends ControlBase implements OnInit {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    public ngOnInit(): void {}
}
